import DOMReady from "../utils/DOMReady";
const HEADER_OFFSET = 80;
// ── Smooth scroll ─────────────────────────────────────────────────────────────
function scrollToAnchor(e, anchor) {
    e.preventDefault();
    const targetId = anchor.replace("#", "");
    const target = document.getElementById(targetId);
    if (target) {
        window.scrollTo({
            top: target.offsetTop - HEADER_OFFSET,
            behavior: "smooth",
        });
        history.pushState(null, "", anchor);
    }
}
// ── Active nav link on scroll ─────────────────────────────────────────────────
function updateActiveNavLink() {
    const sections = document.querySelectorAll("section[id]");
    const links = document.querySelectorAll(".civial-nav__links a, .civial-mobile-menu a[href^='#']");
    let current = "";
    sections.forEach((s) => {
        if (window.scrollY >= s.offsetTop - HEADER_OFFSET - 50)
            current = s.id;
    });
    links.forEach((l) => {
        l.classList.toggle("active", l.getAttribute("href") === `#${current}`);
    });
}
// ── Mobile drawer ─────────────────────────────────────────────────────────────
function initMobileMenu() {
    const btn = document.getElementById("mobile-menu-button");
    const menu = document.getElementById("civial-mobile-menu");
    const overlay = document.getElementById("mobile-overlay");
    const close = document.getElementById("mobile-menu-close");
    if (!btn || !menu || !overlay)
        return;
    function open() {
        menu.classList.add("is-open");
        overlay.classList.add("is-open");
        overlay.removeAttribute("aria-hidden");
        btn.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
    }
    function closeMenu() {
        menu.classList.remove("is-open");
        overlay.classList.remove("is-open");
        overlay.setAttribute("aria-hidden", "true");
        btn.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
    }
    btn.addEventListener("click", open);
    overlay.addEventListener("click", closeMenu);
    close === null || close === void 0 ? void 0 : close.addEventListener("click", closeMenu);
    menu
        .querySelectorAll("a")
        .forEach((a) => a.addEventListener("click", closeMenu));
}
// ── Contact form ──────────────────────────────────────────────────────────────
function initContactForm() {
    const form = document.getElementById("civial-contact-form");
    const submitBtn = document.getElementById("contact-submit");
    const response = document.getElementById("form-response");
    if (!form || !submitBtn || !response)
        return;
    form.addEventListener("submit", async (e) => {
        var _a, _b, _c;
        e.preventDefault();
        const data = new FormData(form);
        data.append("action", "civial_contact_submit");
        submitBtn.disabled = true;
        const originalText = submitBtn.textContent || "Enviar solicitud";
        submitBtn.textContent = "…";
        try {
            const themeObj = window
                .theme;
            const ajaxUrl = (_a = themeObj === null || themeObj === void 0 ? void 0 : themeObj.ajax_url) !== null && _a !== void 0 ? _a : "/wp-admin/admin-ajax.php";
            const res = await fetch(ajaxUrl, {
                method: "POST",
                body: data,
            });
            const json = await res.json();
            response.style.display = "block";
            if (json.success) {
                response.style.color = "#1a7a1a";
                response.textContent =
                    "✓ " + (((_b = json.data) === null || _b === void 0 ? void 0 : _b.message) || "Mensaje enviado.");
                form.reset();
                setTimeout(() => (response.style.display = "none"), 5000);
            }
            else {
                response.style.color = "#c0392b";
                response.textContent =
                    ((_c = json.data) === null || _c === void 0 ? void 0 : _c.message) || "Error al enviar. Inténtelo de nuevo.";
            }
        }
        catch (_d) {
            response.style.display = "block";
            response.style.color = "#c0392b";
            response.textContent = "Error de conexión. Inténtelo de nuevo.";
        }
        finally {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        }
    });
}
// ── Bootstrap ─────────────────────────────────────────────────────────────────
DOMReady(() => {
    initMobileMenu();
    initContactForm();
    document.querySelectorAll('a[href^="#"]').forEach((a) => {
        a.addEventListener("click", (e) => {
            const href = a.getAttribute("href");
            if (href && href !== "#")
                scrollToAnchor(e, href);
        });
    });
    window.addEventListener("scroll", updateActiveNavLink, { passive: true });
    updateActiveNavLink();
    if (window.location.hash) {
        setTimeout(() => {
            scrollToAnchor({ preventDefault: () => undefined }, window.location.hash);
        }, 100);
    }
});
